import { FunctionComponent, ReactNode } from 'react';

import { Header } from '../Header/Header';
import { PanelOverlay } from '../PanelOverlay/PanelOverlay';
import { CustomBackground } from './CustomBackground.styled';
import { InnerPanelWrapper } from './InnerPanelWrapper.styled';

export interface ChatPanelProps {
  initialWidth?: number;
  minWidth?: number;
  maxWidth?: number;
  customBackground?: ReactNode;
  className?: string;
  show: boolean;
  stopAnimation?: boolean;
  children: ReactNode;
  onHide: () => void;
}

export const ChatPanel: FunctionComponent<ChatPanelProps> = ({
  initialWidth,
  minWidth,
  maxWidth,
  className,
  show,
  stopAnimation,
  onHide,
  children,
  customBackground,
}) => {
  return (
    <PanelOverlay
      initialWidth={initialWidth}
      className={className}
      show={show}
      minWidth={minWidth}
      maxWidth={maxWidth}
      stopAnimation={stopAnimation}
    >
      {customBackground && (
        <CustomBackground aria-hidden style={{ pointerEvents: 'none' }}>
          {customBackground}
        </CustomBackground>
      )}
      <InnerPanelWrapper>
        <Header onHide={onHide} />
        {children}
      </InnerPanelWrapper>
    </PanelOverlay>
  );
};
